export const getSourceSetFromWPSizes = ( sizes ) => {
    if (!sizes) {
        return ''
    }

    let srcset = ''

    if (sizes.full) {
        delete sizes.full
    }

    Object.values(sizes).forEach((value, index) => {
        const optionalSeparator = index > 0 ? ', ' : ''
        srcset += `${optionalSeparator}${value.url} ${value.width}w`
    })

    return srcset
}

export const getLargestSourceFromWPSizes = (sizes) => {
    if (sizes.dbec_full_hd) {
        return sizes.dbec_full_hd.url
    }

    if (sizes.dbec_large) {
        return sizes.dbec_large.url
    }

    if (sizes.large) {
        return sizes.large.url
    }

    if (sizes.dbec_medium) {
        return sizes.dbec_medium.url
    }

    if (sizes.full) {
        return sizes.full.url
    }

    if (sizes.medium) {
        return sizes.medium.url
    }

    if (sizes.thumbnail) {
        return sizes.thumbnail.url
    }
}

export const getFullSizeSourceFromWPSizes = (image, sizes) => {

    if (image && image.url) {
        return image.url
    }

    return getLargestSourceFromWPSizes(sizes)
}

export const getSourceFromWPSizesByName = (image, sizeNames) => {
    const { sizes, url } = image

    if (!sizes || !url) {
        console.error('getSourceFromWPSizesByName: no image was given')
        return null
    }

    const sizeName = (Array.isArray(sizeNames) ? sizeNames : [sizeNames]).find((s) => sizes[s] && sizes[s].url)

    if (sizeName) {
        return sizes[sizeName].url
    }

    return url
}

export const GRID_GAP = 35
export const MQ_MEDIUM_UP = 768
export const MQ_LARGE_UP = 1024
export const PADDING_SMALL = 60
export const PADDING_MEDIUM = 130
export const PADDING_LARGE = 130
export const CONTENT_MAX_WIDTH_LARGE = 1200

export const GRID_GAP_PX = `${GRID_GAP}px`
export const MQ_MEDIUM_UP_PX = `${MQ_MEDIUM_UP}px`
export const MQ_LARGE_UP_PX = `${MQ_LARGE_UP}px`
export const PADDING_SMALL_PX = `${PADDING_SMALL}px`
export const PADDING_MEDIUM_PX = `${PADDING_MEDIUM}px`
export const PADDING_LARGE_PX = `${PADDING_LARGE}px`
export const CONTENT_MAX_WIDTH_LARGE_PX = `${CONTENT_MAX_WIDTH_LARGE}px`

const widthCalcByColumnsCount = (maxWidth, c) => {
    return `calc(((${maxWidth} - ${GRID_GAP_PX} * 5) * (${c} / 6)) + (${GRID_GAP_PX} * (${c} - 1)))`
}

const getLargestColumnCountFromColumns = ({ large, medium, small }) => {
    if (large) return large
    if (medium) return medium
    return small
}

export const getSizesStringByColumns = (columns, autocompleteExtraLarge = true) => {
    if (columns === 'full-width') {
        return '100vw'
    }

    const sizes = []

    if (autocompleteExtraLarge) {
        const count = getLargestColumnCountFromColumns(columns) // .large ?? columns.medium ?? columns.small
        const width = count === 6 ? CONTENT_MAX_WIDTH_LARGE_PX : widthCalcByColumnsCount(CONTENT_MAX_WIDTH_LARGE_PX, count)
        sizes.push(`(min-width: ${ CONTENT_MAX_WIDTH_LARGE + PADDING_LARGE }px) ${width}`)
    }

    if (columns.large) {
        const width = columns.large === 6 ? `calc(100vw - ${PADDING_LARGE_PX})` : widthCalcByColumnsCount(`(100vw - ${PADDING_LARGE_PX})`, columns.large)
        sizes.push(`(min-width: ${MQ_LARGE_UP_PX}) ${width}`)
    }

    if (columns.medium) {
        const width = columns.medium === 6 ? `calc(100vw - ${PADDING_MEDIUM_PX})` : widthCalcByColumnsCount(`(100vw - ${PADDING_LARGE_PX})`, columns.medium)
        sizes.push(`(min-width: ${MQ_MEDIUM_UP_PX}) ${width}`)
    }

    if (columns.small) {
        const width = columns.small === 6 ? `calc(100vw - ${PADDING_SMALL_PX})` : widthCalcByColumnsCount(`(100vw - ${PADDING_SMALL_PX})`, columns.small)
        sizes.push(width)
    }

    return sizes.join(', ')
}
